import { combineReducers } from 'redux'
import schemaReducer from './schemaReducer'

export default combineReducers({
    schema: schemaReducer
})